export class StringUtils {
    static uncapitalize(s: string) {
        if (s) {
            return s.charAt(0).toLocaleLowerCase() + s.substr(1);
        } else {
            return null;
        }
    }
}
